import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css'; 

const LoginSignup = ({ setUser, showToast }) => {
  const navigate = useNavigate();
  const [action, setAction] = useState("Login");
  const [otpSent, setOtpSent] = useState(false);
  
  // 🟢 LOADER STATE
  const [isProcessing, setIsProcessing] = useState(false);
  
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    otp: "",
    newPassword: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // API CALLER HELPER
  const callApi = async (endpoint, body) => {
    try {
        const res = await fetch(`/api/auth/${endpoint}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body)
        });
        
        if (!res.ok) {
            const errorText = await res.text();
            throw new Error(errorText);
        }

        const contentType = res.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            return await res.json();
        } else {
            return await res.text();
        }
    } catch (error) {
        throw error;
    }
  };

  // 1. LOGIN
  const handleLogin = async () => {
    if (!formData.username || !formData.password) {
        showToast("⚠️ Please fill all fields."); return;
    }

    setIsProcessing(true); // Start Loader

    try {
        const data = await callApi("login", {
            username: formData.username, 
            password: formData.password
        });

        localStorage.setItem("user", JSON.stringify(data));
        setUser(data);
        showToast(`✅ Welcome back, ${data.username}!`);
        
        setTimeout(() => {
            setIsProcessing(false);
            if (data.role === 'ADMIN') {
                navigate("/admin"); 
            } else {
                navigate("/");      
            }
        }, 1000);
        
    } catch (error) {
        showToast("❌ Login Failed: " + error.message);
        setIsProcessing(false);
    }
  };

  // 2. SIGNUP
  const handleSignup = async () => {
    if (!formData.username || !formData.email || !formData.password) {
        showToast("⚠️ All fields are required!"); return;
    }
    if (formData.password !== formData.confirmPassword) {
        showToast("❌ Passwords do not match!"); return;
    }

    setIsProcessing(true); // Start Loader

    try {
        const response = await callApi("signup", {
            username: formData.username,
            email: formData.email,
            password: formData.password,
            role: "USER"
        });

        showToast("✅ " + response);
        setOtpSent(true);
        setIsProcessing(false);

    } catch (error) {
        showToast("❌ Signup Error: " + error.message);
        setIsProcessing(false);
    }
  };

  // 3. VERIFY
  const handleVerifySignup = async () => {
      if(!formData.otp) { showToast("⚠️ Enter OTP"); return; }
      
      setIsProcessing(true);

      try {
          const response = await callApi("verify", {
              email: formData.email,
              otp: formData.otp
          });
          showToast("✅ " + response);
          setAction("Login");
          setOtpSent(false);
          setIsProcessing(false);
      } catch (error) {
          showToast("❌ Verification Failed: " + error.message);
          setIsProcessing(false);
      }
  };

  // 4. FORGOT PASSWORD
  const handleForgotPassword = async () => {
      if(!formData.email) { showToast("⚠️ Enter Email"); return; }
      
      setIsProcessing(true);

      try {
          const response = await callApi("forgot-password", { email: formData.email });
          showToast("✅ " + response);
          setOtpSent(true);
          setIsProcessing(false);
      } catch (error) {
          showToast("❌ Error: " + error.message);
          setIsProcessing(false);
      }
  };

  // 5. RESET PASSWORD
  const handleResetPassword = async () => {
      if(!formData.otp || !formData.newPassword) { showToast("⚠️ Enter OTP and New Password"); return; }
      
      setIsProcessing(true);

      try {
          const response = await callApi("reset-password", {
              email: formData.email.trim(),
              otp: formData.otp.trim(),
              newPassword: formData.newPassword
          });
          showToast("✅ " + response);
          setAction("Login");
          setOtpSent(false);
          setIsProcessing(false);
      } catch (error) {
          showToast("❌ Reset Failed: " + error.message);
          setIsProcessing(false);
      }
  };

  return (
    <div className='loginsignup'>
      
      {/* 🟢 CLEAN PROCESSING LOADER (No Text) */}
      {isProcessing && (
        <div className="processing-overlay">
            <img 
                src="/loader-logo.png" 
                alt="Loading..." 
                style={{ width: '80px', height: '80px' }} // Size control
            />
        </div>
      )}

      <div className="loginsignup-container">
        
        {/* BRAND HEADER */}
        <div style={{ 
            display: 'flex', 
            flexDirection: 'row', 
            alignItems: 'center', 
            justifyContent: 'center', 
            gap: '15px', 
            

            borderBottom: '1px solid #eee' 
        }}>
            <img 
                src="/loader-logo.png" 
                alt="Antarvaani Logo" 
                style={{ width: '50px', height: '50px', objectFit: 'contain' }} 
            />
            <h2 style={{ 
                margin: 0, 
                fontSize: '1.8rem', 
                fontWeight: '900', 
                letterSpacing: '2px', 
                textTransform: 'uppercase',
                color: 'black'
            }}>
                ANTARVAANI
            </h2>
        </div>

        <h1>{action}</h1>
        
        <div className="loginsignup-fields">
          
          {/* LOGIN */}
          {action === "Login" && (
            <>
                <input type="text" name="username" placeholder='Username or Email' value={formData.username} onChange={handleChange} />
                <input type="password" name="password" placeholder='Password' value={formData.password} onChange={handleChange} />
                <button onClick={handleLogin} disabled={isProcessing}>
                    Login
                </button>
                <p className="loginsignup-login">
                    Forgot Password? <span onClick={() => {setAction("Forgot Password"); setOtpSent(false);}}>Click Here</span>
                    <br/>
                    New here? <span onClick={() => {setAction("Sign Up"); setOtpSent(false);}}>Create an account</span>
                </p>
            </>
          )}

          {/* SIGNUP */}
          {action === "Sign Up" && (
            <>
                {!otpSent ? (
                    <>
                        <input type="text" name="username" placeholder='Username' value={formData.username} onChange={handleChange} />
                        <input type="email" name="email" placeholder='Email Address' value={formData.email} onChange={handleChange} />
                        <input type="password" name="password" placeholder='Create Password' value={formData.password} onChange={handleChange} />
                        <input type="password" name="confirmPassword" placeholder='Confirm Password' value={formData.confirmPassword} onChange={handleChange} />
                        <button onClick={handleSignup} disabled={isProcessing}>
                            Register & Get OTP
                        </button>
                    </>
                ) : (
                    <>
                        <p style={{fontSize:'0.9rem'}}>OTP sent to {formData.email}</p>
                        <input type="text" name="otp" placeholder='Enter OTP' value={formData.otp} onChange={handleChange} />
                        <button onClick={handleVerifySignup} disabled={isProcessing}>
                            Verify Account
                        </button>
                    </>
                )}
                <p className="loginsignup-login">
                    Already have an account? <span onClick={() => {setAction("Login"); setOtpSent(false);}}>Login here</span>
                </p>
            </>
          )}

          {/* FORGOT PASSWORD */}
          {action === "Forgot Password" && (
            <>
                {!otpSent ? (
                    <>
                        <input type="email" name="email" placeholder='Enter your Email' value={formData.email} onChange={handleChange} />
                        <button onClick={handleForgotPassword} disabled={isProcessing}>
                            Send OTP
                        </button>
                    </>
                ) : (
                    <>
                        <input type="text" name="otp" placeholder='Enter OTP' value={formData.otp} onChange={handleChange} />
                        <input type="password" name="newPassword" placeholder='New Password' value={formData.newPassword} onChange={handleChange} />
                        <button onClick={handleResetPassword} disabled={isProcessing}>
                            Reset Password
                        </button>
                    </>
                )}
                <p className="loginsignup-login">
                    <span onClick={() => {setAction("Login"); setOtpSent(false);}}>Back to Login</span>
                </p>
            </>
          )}

        </div>
      </div>
    </div>
  );
};

export default LoginSignup;